// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"6b3f454c","858":"a957051f"}[chunkId] + ".chunk.css";
};